import { MdContacts } from 'react-icons/md';

import { APP_ROUTES } from '@shared/lib';

import { ISidebarSection } from '../../Sidebar.types';

export const SIDEBAR_SECTIONS: ISidebarSection[] = [
  {
    title: 'Invoice Generator',
    path: APP_ROUTES.generator.employees,
    Icon: MdContacts,
  },
];
